export default __webpack_public_path__ + "static/media/white-tiktok.d29da6bd.svg";